import http from 'hub-http/clients/apiClient';
import { PROMOTIONS } from '../constants/EarlyRequesterNames';
import getEarlyRequesterResult from './getEarlyRequesterResult';
const ENDPOINT = 'promotion/v4/promotions';
export const getPromotions = () => {
  const earlyRequest = getEarlyRequesterResult(PROMOTIONS);
  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => http.get(ENDPOINT)) : null;
  return earlyRequestWithRetry || http.get(ENDPOINT);
};